export const INGRESO = { ID: 1, CODIGO: 'I' }
export const SALIDA = { ID: 2, CODIGO: 'S' }